<template>
  <div class="document-management">
    <!-- Formulário -->
    <div class="form-container">
      <h2>Formulário de Documento</h2>
      <section>
        <InputGroup>
          <InputWrapper>
            <el-select
              v-model="document.profile_user"
              placeholder="Perfil de usuário"
              filterable
              size="large"
              clearable
            >
              <el-option
                v-for="item in userTypes"
                :key="item.id"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </InputWrapper>
          <InputWrapper>
            <el-select
              v-model="document.type"
              placeholder="Tipo"
              filterable
              size="large"
              clearable
            >
              <el-option
                v-for="item in getDocumentsTypes"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </InputWrapper>
        </InputGroup>
        <div class="file-upload">
          <el-label class="doc-name" for="document-name"
            >Nome do documento:</el-label
          >
          <el-input type="text" id="document-name" v-model="document.name" />

          <input
            type="file"
            id="file-input"
            @change="onFileChange"
            ref="fileInput"
          />
          <div class="select-doc">
            <el-button type="primary" @click="triggerFileInput">
              Escolher arquivo
            </el-button>
          </div>
        </div>
      </section>
      <div class="save">
        <el-button type="primary" @click="handleSave">Salvar</el-button>
      </div>
    </div>

    <!-- Tabela -->
    <div class="table-container">
      <h2>Lista de Documentos</h2>
      <el-table
        :data="tableData"
        :height="450"
        style="width: 100%; margin-top: 15px;"
        empty-text="Não há dados para serem listados"
        border
        v-loading="isLoading"
      >
        <el-table-column
          prop="name"
          label="Nome"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="createdAt"
          label="Data do registro"
          align="center"
        ></el-table-column>
        <el-table-column label="Ação" width="150" align="center">
          <template v-slot="scope">
            <div class="actions">
              <font-awesome-icon :icon="iconEdit" @click="edit(scope.row)" />
              <font-awesome-icon
                :icon="iconCancel"
                @click="cancel(scope.row)"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          v-if="getTotalPages > 1"
          layout="prev, pager, next"
          :total="getTotalContent"
          :current-page="getPage"
          @current-change="handlePageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { faBan, faPenToSquare } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { format } from 'date-fns'
import { mapGetters, mapActions } from 'vuex'

import InputGroup from '@/components/inputGroup'
import InputWrapper from '@/components/inputWrapper'

export default {
  name: 'DocumentManagement',

  components: {
    FontAwesomeIcon,
    InputWrapper,
    InputGroup
  },

  data() {
    return {
      iconEdit: faPenToSquare,
      iconCancel: faBan,
      tableData: [],
      document: {
        name: '',
        // eslint-disable-next-line camelcase
        profile_user: null,
        type: null,
        createdAt: '',
        path: ''
      },
      currentPage: 1,
      pageSize: 10,
      userTypes: [
        { id: 1, name: 'Admin', value: 'admin' },
        { id: 2, name: 'Consultor da indústria', value: 'agent' },
        {
          id: 3,
          name: 'Gestor Consultor da indústria',
          value: 'agent_manager'
        },
        { id: 4, name: 'Médico solicitante', value: 'client_doctor' },
        { id: 5, name: 'Médico consultor', value: 'consultant_doctor' }
      ]
    }
  },

  mounted() {
    this.fetchDocuments()
    this.fetchDocumentsTypes()
  },

  computed: {
    ...mapGetters('documentManagement', [
      'getDocument',
      'getDocuments',
      'getLoadingDocument',
      'getTotalPages',
      'getTotalContent',
      'getPage'
    ]),
    ...mapGetters('documentType', ['getDocumentsTypes']),

    isLoading() {
      return this.getLoadingDocument
    }
  },

  watch: {
    getPage: 'fetchDocuments',
    getDocuments: {
      handler(documents) {
        this.tableData = documents?.map((doc) => ({
          name: doc?.name,
          createdAt: doc ? format(new Date(doc.createdAt), 'dd/MM/yyyy') : '',
          id: doc?.id
        }))
      },
      deep: true
    }
  },

  methods: {
    ...mapActions('documentManagement', [
      'fetchDocument',
      'fetchDocuments',
      'deleteDocument',
      'updatePage',
      'createDocument',
      'editDocument',
      'postFile'
    ]),
    ...mapActions('documentType', ['fetchDocumentsTypes']),

    onFileChange(event) {
      const file = event.target.files[0]
      this.file = file
    },

    triggerFileInput() {
      this.$refs.fileInput.click()
    },

    handleSave() {
      if (this.document.id) {
        this.editDocument(this.document).then(() => {
          this.uploadFile(this.document.id)
          this.clearForm()
        })
      } else {
        this.createDocument(this.document).then((response) => {
          if (response && response.data) {
            this.uploadFile(response.data.id.id)
          }
          this.clearForm()
        })
      }
    },

    uploadFile(documentId) {
      if (this.file) {
        this.postFile({ file: this.file, id: documentId }).then(() => {
          this.file = null
        })
      }
    },

    clearForm() {
      this.document = {
        name: '',
        // eslint-disable-next-line camelcase
        profile_user: null,
        type: null,
        path: ''
      }
    },

    edit(row) {
      this.fetchDocument(row.id).then(() => {
        this.document = { ...this.getDocument }
        this.scrollToTop()
      })
    },

    cancel(row) {
      this.deleteDocument(row.id)
    },

    handlePageChange(newPage) {
      this.updatePage(newPage)
    },

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/index.scss';

.form-container,
.table-container {
  margin-bottom: 20px;
}

.actions {
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-size: 19px;
  margin: 2px;

  svg:hover {
    cursor: pointer;
    transform: translateY(-2px);
    transition: transform 0.2s ease;
  }
}

.input-group {
  padding: 10px 0;
}
</style>
